import script from "./ChatRecipients.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChatRecipients.vue?vue&type=script&lang=ts&setup=true"

import "./ChatRecipients.vue?vue&type=style&index=0&id=1730cc5a&scoped=true&lang=css"
/* custom blocks */
import block0 from "./ChatRecipients.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1730cc5a"]])

export default __exports__